import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const Button = styled.div<{ $shouldCenter }>`
    background-color: ${({ theme }) => theme.Surface.Opposite.primary};
    color: ${({ theme }) => theme.Surface.border};
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    padding: 8px 24px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
    border: ${({ theme }) => '1px solid' + theme.Surface.border};
    box-shadow: ${BaseStyle.Mixins.utility.fadedBoxShadow};
    cursor: pointer;
    user-select: none;
    z-index: 3;
    position: fixed;

    // centers the fixed position element
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: 32px;

    ${({ $shouldCenter }) =>
        !$shouldCenter &&
        css`
            ${BaseStyle.Mixins.screenSizes.medium} {
                transform: revert;
                left: revert;
                width: fit-content;
                right: 32px;
            }
        `}
`;
